module.exports = __webpack_public_path__ + "img/waterpolo-5.cae573c2.png";